// セッション有効期限の判定・失効時のリダイレクト・レポート(PDF)を開く共通ヘルパー
const LOGIN_PATH = '/login';
let _redirecting = false; // 二重リダイレクト防止

// w_auth があり、かつ w_authExp を過ぎていれば「失効」
export function isSessionExpired() {
  try {
    const t = localStorage.getItem('w_auth');
    const exp = localStorage.getItem('w_authExp');
    if (!t || !exp) return false; // 未ログインは「失効」ではない
    return Date.now() > Number(exp);
  } catch (e) {
    return false;
  }
}

export function clearSession() {
  try {
    localStorage.removeItem('w_auth');
    localStorage.removeItem('w_authExp');
    localStorage.removeItem('w_authRenewAt');
  } catch (e) {}
}

// 現在の画面(現在のウィンドウ)からログインへ遷移。新しいタブは開かない。returnTo で復帰先を渡す。
export function redirectToLogin(opts) {
  const withAlert = opts && opts.withAlert;
  if (_redirecting) return;
  if (window.location.pathname.startsWith(LOGIN_PATH)) {
    clearSession();
    return;
  }
  _redirecting = true;
  clearSession();
  if (withAlert) {
    try {
      window.alert('セッションの有効期限が切れました。再度ログインしてください。');
    } catch (e) {}
  }
  const returnTo = window.location.pathname + window.location.search;
  const q = returnTo && returnTo !== '/' ? '?returnTo=' + encodeURIComponent(returnTo) : '';
  window.location.href = LOGIN_PATH + q;
}

// レポート(PDF)を開く。セッション失効時は新しいタブを開かず、現在のウィンドウでログインへ。
export function openReport(tokenId) {
  if (isSessionExpired()) {
    redirectToLogin({ withAlert: true });
    return;
  }
  window.open('/api/report/' + tokenId + '/pdf', '_blank');
}
